<template lang="pug">
transition(
  v-on:enter="enter"
  v-on:leave="leave"
  )
  .gallery
    .bg(ref="bg")
      bg-pattern
      .button-back(ref="backBtn" @click="closeGallery")
        icon-arrow
      //.logo
        img(src="~assets/ui/logo/logo-kids.png")
      .selected-img
        .hero
          template(v-if="gallery.length > 0")
            img(:src="gallery[selected][0]")
            img.shadow-img(:src="gallery[selected][1]")
            svg.shadow(viewBox="0 0 228 327" fill="none" xmlns="http://www.w3.org/2000/svg")
              use(xlink:href="#photo-shadow")
          template(v-else)
            img.placeholder(src="~assets/ui/empty.svg")
        .copy 长按图片保存或分享
      .flex-blank
      .imgs
        .bag(:class="{'active': bagActive}")
          img(src="~assets/ui/bag2.png")
        .swiper-container(id="img-slide")
          .swiper-wrapper
            .swiper-slide(v-for="(img,index) in gallery" :key="index" )
              .photo(@click="select(index)" :style="`transform: scale(${index === selected? 1.2: 1}) rotateZ(${index === selected? 0 : (index%2===0? -1:1)*(Math.random()*3+2)}deg);`")
                img(:src="`${img[2]}`")
            //.swiper-slide.blank
              //.icon
                icon-check(:check="index === selected")
      img.bg-spark(src="~assets/ui/spark.png")


</template>
<script>
import * as THREE from 'three'
import { Swiper } from 'swiper/dist/js/swiper.esm.js'
var shot = require("src/assets/ui/screenshot.png")
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2} from 'gsap'
import BgPattern from 'src/components/vca/widgets/BgPattern'
//import IconClose from 'src/components/vca/widgets/IconClose'
import IconCheck from 'src/components/vca/widgets/IconCheck'
import IconArrow from 'src/components/vca/widgets/IconArrow'

export default {
  name: "Gallery",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    //IconClose,
    IconCheck,
    IconArrow,
    BgPattern
  },
  data() {
    return {
      shot: shot,
      selected: 0,
      bagActive: false
    }
  },
  computed:{
    ...mapState('app', ['gallery']),

  },
  methods: {
    ...mapMutations('app', ['closeGallery', 'addToGallery']),
    init() {
      //this.addToGallery(this.shot)
      //this.addToGallery(this.shot)
      //this.addToGallery(this.shot)
      //this.addToGallery(this.shot)
      //console.log(window.screen.height/window.screen.width)
      let ratio = window.screen.height/window.screen.width
      let spv = 4
      let sb = 30
      if (ratio < 2){
        spv = 5
      }
      if (ratio < 1.6){
        spv = 6
      }

      this.swiper = new Swiper('#img-slide', {
      slidesPerView: spv,
      slidesOffsetBefore: 100,
      slidesOffsetAfter: 80,
      spaceBetween: 30,
      //setWrapperSize: true,
      freeMode: true,
      on: {
        reachBeginning: () => {
          this.bagActive = false
        },
        fromEdge: () => {
          this.bagActive = true
        }
      }
    })

    },
    select(i){
      this.selected = i
    },
    animateIn(cb) {

      let tl = new TimelineMax({ onComplete: cb})
      this.tl = tl

      tl.add('start')
        .to(
          this.$refs.bg,
          0.7,
          {
            opacity: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )

    },
    enter(el, done){
      this.animateIn(done)

    },
    leave(el, done){
      this.tl.eventCallback('onReverseComplete', done)
      this.tl.reverse()

    }
  },
  mounted() {
    this.init()
    //this.animate()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  @import "src/styles/helpers/swiper.sass"
  .gallery
    +full()
    .bg
      opacity: 0
      width: 100%
      height: 100%
      display: flex
      flex-direction: column
      justify-content: space-around
      align-items: center
      background: #FD9F02
      overflow: hidden
      .bg-pattern
        mix-blend-mode: color-burn
      .button-back
        //background: greenyellow
        line-height: 0
        position: absolute
        width: 0.53rem
        padding: 0.1rem 0.2rem
        transform: scale(-1)
        font-size: $fs-m

        top: $ui-margin-top - 0.4rem
        left: $ui-margin-left - 0.12rem
        pointer-events: all
      .logo
        width: 100%
        text-align: center
        img
          display: inline-block
          width: 25%

      .selected-img
        width: 100%
        margin-top: 1.5rem
        //background: greenyellow
        //text-align: center
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        .hero
          height: 90vw
          position: relative
          transform: rotateZ(3.02deg)
          transform-origin: center

          img
            display: block
            //height: 4.2rem
            height: 100%
            border: 15px #FFF9EE solid
            border-radius: 5px
            border-bottom: 0.45rem #FFF9EE solid
            position: relative
            z-index: 100

            &.shadow-img
              opacity: 0
              pointer-events: all
              position: absolute
              z-index: 101
              top: 0
              left: 0
            &.placeholder
              border: none
          svg
            display: block
            height: 100%
            position: absolute
            top: 0
            left: 0
            z-index: 99
            transform: rotateZ(-3deg) scale(1.01) translate3d(-3%, 7%, 0)



        .placeholder
          pointer-events: none
          border: none
        .copy
          position: relative
          z-index: 12
          margin-top: 0.2rem
          font-size: $fs-s
          background: rgba(227, 130, 3, 0.3)
          color: #FFF9EE
          line-height: $fs-s*2
          width: 2.2rem
          border-radius: $fs-s
          text-align: center
      .flex-blank
        width: 100%
        height: 1rem
      .bg-spark
        pointer-events: none
        +full()
        display: block
        z-index: 10
      .imgs
        z-index: 11
        width: 100%
        //background: #3a602e
        position: absolute
        bottom: -0.1rem
        #img-slide
          width: calc(100% - 0.5rem)
          left: 0.5rem
          position: relative
        .bag
          position: absolute
          margin-right: 0.1rem !important
          width: 1.3rem !important
          //background-color: red
          top: 0.35rem
          left: 0.1rem
          -webkit-transition: all 0.2s ease-out
          -moz-transition: all 0.2s ease-out
          -ms-transition: all 0.2s ease-out
          -o-transition: all 0.2s ease-out
          transition: all 0.2s ease-out
          transform-origin: center
          &.active
            transform: translate3d(-40%, 0, 0)

          img
            display: block
            width: 1rem
            line-height: 0


            //margin-right: 1rem
            border: none
        .photo
          line-height: 0
          height: 1rem !important
          width: 0.6rem !important
          //background: red
          margin-top: 0.28rem
          -webkit-transition: all 0.2s ease-out
          -moz-transition: all 0.2s ease-out
          -ms-transition: all 0.2s ease-out
          -o-transition: all 0.2s ease-out
          transition: all 0.2s ease-out
          //margin-right: 0.3rem !important
          transform-origin: center
          //&:first-child
            margin-left: 1rem
          img
            display: block
            height: 1rem
            border: 5px #FFF9EE solid
            border-radius: 2px


          //&.selected
            transform-origin: center
            transform: scale(1.2)
          //.icon
            width: 0.25rem
            position: absolute
            bottom: -0.1rem
            right: 0.05rem
        .blank
          width: 0.6rem


</style>